import { useTranslation } from 'react-i18next';
import ConfirmDestructiveModal from '../common/ConfirmDestructiveModal';
import { softBreakIdentifier } from '../../utils/softBreakIdentifier';

interface StorageRoomDeleteModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => Promise<void>;
  storageRoomName: string;
  isLoading?: boolean;
}

/** 保管庫削除確認（共通 ConfirmDestructiveModal の薄いラッパ） */
export default function StorageRoomDeleteModal({
  show,
  onHide,
  onConfirm,
  storageRoomName,
  isLoading = false,
}: StorageRoomDeleteModalProps) {
  const { t } = useTranslation();

  return (
    <ConfirmDestructiveModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title={t('storage_room.delete_confirm_title')}
      message={t('storage_room.delete_confirm_message')}
      closeTitle={t('storage_room.delete_modal_close_title', {
        defaultValue: '保管庫削除の確認を閉じる',
      })}
      cancelTitle={t('storage_room.delete_cancel_title', {
        defaultValue: '削除せずに閉じる',
      })}
      confirmTitle={t('storage_room.delete_confirm_ok_title', {
        defaultValue: 'この保管庫を削除する',
      })}
    >
      <p className="fw-bold">{softBreakIdentifier(storageRoomName, t)}</p>
      <p className="text-danger small mb-0">{t('storage_room.delete_warning')}</p>
    </ConfirmDestructiveModal>
  );
}
